/**
 * Created by r4zi4l on 20.08.2021
 */

Families.initialize = function () {
    Families.initializeBase();

    AdventureFamilies.register();

    Families.DELETED_STAGES.wood = [5];
    Families.DELETED_STAGES.stone = [5];

    Families.DELETED_STAGES.bear = [4];
    Families.DELETED_STAGES.knight = [1];
    Families.DELETED_STAGES.hunter = [4];

    Families.DELETED_STAGES.woodgenerator = [1, 2];
    Families.DELETED_STAGES.stonegenerator = [1, 2];
    Families.DELETED_STAGES.wagongenerator = [1, 2];
    Families.DELETED_STAGES.bamboogenerator = [1, 2];
    Families.DELETED_STAGES.sapphiregenerator = [1, 2];
    Families.DELETED_STAGES.snowgenerator = [1, 2];
    Families.DELETED_STAGES.lavagenerator = [1, 2];
    Families.DELETED_STAGES.sandgenerator = [1, 2];
    Families.DELETED_STAGES.asiagenerator = [1, 2];
    Families.DELETED_STAGES.warcraftgenerator = [1, 2];
    Families.DELETED_STAGES.steampunkgenerator = [1, 2];
    Families.DELETED_STAGES.moonstonegenerator = [1, 2];
    Families.DELETED_STAGES.leafgenerator = [1, 2];

    [].forEach((code) => {
        Families.DEBUG_ONLY[code] = true;
    });

    if (!cleverapps.config.debugMode) {
        Object.keys(Families.DEBUG_ONLY).forEach((code) => {
            delete Families[code];
        });
    }

    delete Families.vampire;
    delete Families.vampirechest;
    delete Families.vampiresource;
    delete Families.vampiregenerator;

    delete Families.wax;
    delete Families.waxchest;
    delete Families.waxsource;
    delete Families.waxgenerator;

    delete Families.dragonmine;

    delete Families.kingfood;
    delete Families.dwarffood;

    Families.afterInitialize();
};

if (typeof cc === "undefined") {
    module.exports = Families;
}
